import { axiosInstance } from "./AxiosInstance";

const API_URL = "/branches";
const BRANCHES_PAGE_CAP = 100;
const BRANCHES_DEFAULT_LIMIT = 10;

export const getBranches = async (limit = 10, page = 1, search = '', includeTotal = true, fields = '') => {
  try {
    const safeLimit = Math.max(1, Math.min(BRANCHES_PAGE_CAP, Number.parseInt(limit, 10) || BRANCHES_DEFAULT_LIMIT));
    const safePage = Math.max(1, Number.parseInt(page, 10) || 1);
    const safeSearch = search || "";
    const fieldsParam = fields ? `&fields=${fields}` : "";
    const response = await axiosInstance.get(
      `${API_URL}?limit=${safeLimit}&page=${safePage}&search=${safeSearch}&includeTotal=${includeTotal ? "true" : "false"}${fieldsParam}`
    );
    return {
      data: response.data.data,       // Actual branch data
      pagination: response.data.pagination // Pagination info
    };
  } catch (error) {
    console.error("Error fetching branches", error);
    throw error;
  }
};

/**
 * Load all branches by paging in chunks under 50.
 * The backend's list endpoint switches to a broken streaming response whenever
 * the requested page size is >= 50 (AUTO_STREAM_LIMIT), returning a raw Stream
 * object instead of an array. Paging in small chunks avoids that path entirely.
 */
export const fetchAllBranches = async (search = "") => {
  const all = [];
  let page = 1;
  const limit = 40;
  const maxPages = 200;
  while (page <= maxPages) {
    // Callers only build dropdowns from this, so only id + name are fetched.
    const { data } = await getBranches(limit, page, search, false, "id,name");
    const chunk = Array.isArray(data) ? data : [];
    if (!chunk.length) break;
    all.push(...chunk);
    if (chunk.length < limit) break;
    page += 1;
  }
  return all;
};

export const addBranch = async (branchData) => {
  try {
    const response = await axiosInstance.post(API_URL, {
      ...branchData,
      isDeleted: false,
    });
    return response.data;
  } catch (error) {
    console.error("Error adding branch", error);
    throw error;
  }
};

export const updateBranch = async (branchId, branchData) => {
  try {
    const response = await axiosInstance.put(
      `${API_URL}/${branchId}`,
      branchData
    );
    return response.data;
  } catch (error) {
    console.error("Error updating branch", error);
    throw error;
  }
};

export const deleteBranch = async (branchId) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/${branchId}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting branch", error);
    throw error;
  }
};

export const getBranchById = async (branchId) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/${branchId}`);
    return {
      data: response.data.data, // Ensure consistent structure
      status: response.status,
      message: response.data.message
    };
  } catch (error) {
    console.error("Error fetching branch details", error);
    throw error;
  }
};
